export default __webpack_public_path__ + "images/20d54ab1b3f39da9ece95ca1c79eafe6-theatre.jpg";